






















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import PostalCodeSearch from '@/modules/geo/components/PostalCodeSearch.vue'
import { PostalCode } from '@/modules/geo/types';
import { Action, State, Getter, Mutation } from 'vuex-class'
import Rate from '@/modules/shipping/model/Rate'
import RateSelect from '@/modules/shipping/components/RateSelect.vue'
import CalculationMode from '@/modules/shipping/model/CalculationMode'
import * as api from '@/modules/shipping/api'
import {Colors, notify} from '@/modules/core/notification';

@Component({
    components: {
        PostalCodeSearch,
        RateSelect,
    },
})
export default class CostCalculator extends Vue {
    @Prop({type: Boolean, default: false})
    public value: boolean

    public loading = false

    public rate = new Rate()

    public postalCode: PostalCode | null = null
    public quantity = 0
    public calculationMode = CalculationMode.PostalCodeByRateSelection
    public result: api.CalculationResult = {
        matched: false,
        isShippingFree: false,
    }

    public calculationModes = [
        { value: CalculationMode.PostalCodeByRateSelection, text: 'Por código postal con tarifa predefinida'},
        { value: CalculationMode.PostalCodeRatePriority, text: 'Por código postal con prioridad de tarifa'},
    ]

    public notMatched = false

    public async calculate () {
        this.loading = true
        this.notMatched = false
        this.result = await api.calculateCost({
            mode: this.calculationMode,
            postalCode: this.postalCode!,
            rate: this.rate,
            quantity: this.quantity,
        })

        this.notMatched = !this.result.matched

        this.loading = false
    }

    public errorCaptured () {
        this.loading = false
        notify('Se ha producido un error al calcular el importe', Colors.Error)
    }
}
